window.MTGGoldfishMetagame = window.MTGGoldfishMetagame || {};

window.MTGGoldfishMetagame.onDocumentReady = function() {

  var currentPrice;
  var priceToShow;

  function getPriceType(preference) {
    if (["paper", "online", "arena"].includes(preference)) return preference;
    if (["my-paper", "my-online", "my-arena"].includes(preference)) {
      return preference.replace(/^my-/, "");
    }
    return null;
  }

  function getHashTarget(href) {
    var match = href.match(/tab-(my-)?(paper|online|arena)$/);
    if (!match) return null;
    return "#" + (match[1] ? "my-" : "") + match[2];
  }

  function setToggle(selector, show) {
    document.querySelectorAll(selector).forEach(function(el) {
      if (!show) {
        el.style.display = 'none';
      } else if (el.tagName === 'SPAN') {
        el.style.display = 'inline';
      } else {
        el.style.display = 'block';
      }
    });
  }

  var showTab = function(preference) {
    console.log("Metagame showTab");
    document.querySelectorAll('.type-switcher-tabs a[data-bs-toggle="tab"]').forEach(function(el) {
      var href = el.getAttribute("href") || '';
      if (href.match("tab-" + preference)) {
        bootstrap.Tab.getOrCreateInstance(el).show();
      }
    });

    var selectedType = getPriceType(preference);
    if (!selectedType) {
      if (!currentPrice) currentPrice = getDefaultPreference();
      priceToShow = currentPrice;
    } else {
      priceToShow = selectedType;
      currentPrice = selectedType;
    }

    if (priceToShow === 'paper') {
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-paper", true);
      setToggle(".deck-price-arena", false);
    } else if (priceToShow === 'online') {
      setToggle(".deck-price-online", true);
      setToggle(".deck-price-paper", false);
      setToggle(".deck-price-arena", false);
    } else if (priceToShow === 'arena') {
      setToggle(".deck-price-arena", true);
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-paper", false);
    }
  }

  document.addEventListener('click', function(e) {
    if (!e.target) return;
    var link = e.target.closest('.deck-container-main .type-switcher-tabs a');
    if (!link) return;
    if (!link.classList.contains("regular-link")) {
      e.preventDefault();
      bootstrap.Tab.getOrCreateInstance(link).show();
      var href = link.getAttribute('href') || '';
      var target = getHashTarget(href);
      if (!target) return;

      if (history.pushState) history.pushState(null, null, target);
      else window.location.hash = target;
    }
  });

  document.addEventListener('shown.bs.tab', function(e) {
    var tabEl = e.target;
    var container = tabEl.closest('.deck-container-main');
    if (!container || !tabEl.matches('[data-bs-toggle="tab"]')) return;

    var dropdownTarget = container.querySelector(".type-switcher-tabs .deck-type-dropdown-menu .nav-link");
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget || '';
    var dropdownClazz = getPriceType(hash.replace(/#.*tab-/, ""));
    var dropdownClazzLabelText = tabEl.textContent.trim();

    if (dropdownTarget && dropdownClazz) updateDropdownTypeToggle(dropdownTarget, dropdownClazz, dropdownClazzLabelText);

    var selectedType = getPriceType(hash.replace(/#.*tab-/, ""));
    if (selectedType === 'paper') {
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-paper", true);
      setToggle(".deck-price-arena", false);
    } else if (selectedType === 'online') {
      setToggle(".deck-price-online", true);
      setToggle(".deck-price-paper", false);
      setToggle(".deck-price-arena", false);
    } else if (selectedType === 'arena') {
      setToggle(".deck-price-arena", true);
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-paper", false);
    }
  });

  // Initialize based on URL hash or cookie
  var url = document.location.toString();
  if (url.match('#')) {
    showTab(url.split('#')[1]);
  } else {
    var preference = getDefaultPreference();
    history.replaceState(null, null, '#' + preference);
    showTab(preference);
  }

  function getDefaultPreference() {
    var preference = Cookies.get('type-preference');
    if (preference === "online" || preference === "arena") return preference;
    return "paper";
  }

  window.addEventListener("popstate", function(e) {
    var popUrl = document.location.toString();
    if (popUrl.match('#')) showTab(popUrl.split('#')[1]);
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest('#deck-like-btn')) return;
    var btn = e.target.closest('#deck-like-btn');
    btn.disabled = true;
    var id = btn.dataset.id;
    var action = btn.dataset.action;
    var logged = btn.dataset.logged;
    if (logged) {
      var token = document.querySelector('meta[name="csrf-token"]').content;
      fetch('/deck/vote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': token
        },
        body: new URLSearchParams({ id: id, vote: action }),
        credentials: 'same-origin'
      });
    } else {
      bootstrap.Modal.getOrCreateInstance(document.querySelector('#login-modal')).show();
    }
  });
};
